var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMe = function SvgMe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2001D",
    d: "M24 12c0-4.119-2.075-7.752-5.236-9.913H5.237A11.987 11.987 0 0 0 0 12c0 4.118 2.075 7.752 5.237 9.913h13.526A11.986 11.986 0 0 0 24 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M9.392 8.87h5.217V6.783l-1.043.522L12 5.74l-1.565 1.565-1.043-.522V8.87ZM16.696 12h-2.608a1.204 1.204 0 1 0-2.104-1.169 1.204 1.204 0 1 0-2.103 1.17H7.305c0 .797.695 1.444 1.493 1.444H8.75c0 .655.435 1.207 1.032 1.385l-1.173 1.173 1.107 1.106 1.57-1.57c.061.023.125.04.19.053l-.948 2.142a3.899 3.899 0 0 0 2.945 0l-.949-2.142c.066-.012.13-.03.191-.053l1.57 1.57 1.107-1.106-1.173-1.173a1.445 1.445 0 0 0 1.032-1.385h-.048c.798 0 1.493-.647 1.493-1.445Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "m12 12.783-1.695.782v1.566L12 16.174l1.696-1.043v-1.566L12 12.783Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M13.696 12h-3.391v2.086h3.391V12Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgMe;